const Users = () => import(/* webpackChunkName: "users setting" */ '@/components/users')
export default {
    name: 'users',
    path: 'settings/users',
    redirect: '/settings/users/index',
    meta: {label: 'users'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7]},
            component: Users,
            props: true
        }
    ]
}
